import { c as createFocusTrap } from './focus-trap.esm-BUj_YYcQ.js';

class TabElement extends HTMLElement {
  connectedCallback() {
    this.setupEventListeners();
    this.setupFocusTrap();
    this.initializeTabElements();
    this.setupControllerBar();
    this.setAttribute('data-init', 'true');

    /**
     * Listen to extra events when in Shopify editor
     */
    if (Shopify.designMode) {
      window.addEventListener('shopify:section:load', (event) => {
        this.activateTabByBlockEvent(event);
      });

      window.addEventListener('shopify:block:select', (event) => {
        this.activateTabByBlockEvent(event);
      });

      window.addEventListener('shopify:block:deselect', (event) => {
        this.activateTabByBlockEvent(event);
      });
    }
  }

  activateTabByBlockEvent(event) {
    const controllerId = event.target.closest('[aria-labelledby]')?.getAttribute('aria-labelledby');
    if (!controllerId) return;

    const controller = this.querySelector(`#${controllerId}`);
    if (!controller) return;

    this.handleClick(controller);
  }

  setupEventListeners() {
    this.addEventListener('click', (event) => {
      const controller = event.target.closest('[aria-controls]');
      this.handleClick(controller);
    });
  }

  setupFocusTrap() {
    this.trap = createFocusTrap(this, {
      allowOutsideClick: true,
      fallbackFocus: this,
      clickOutsideDeactivates: true,
      initialFocus: false,
    });
  }

  initializeTabElements() {
    this.tabControllers = this.querySelectorAll('[aria-controls]');
    this.tabPanels = this.querySelectorAll('[aria-labelledby]');
  }

  setupControllerBar() {
    this.controllerBar = this.querySelector('[role="tablist"]');
    if (this.controllerBar.children.length === 0 && this.tabControllers.length > 0) {
      this.tabControllers.forEach((controller) => {
        this.controllerBar.appendChild(controller);
      });
      this.tabControllers[0].click();
    }
  }

  handleClick(controller) {
    // Get the tab id from the controller
    const tabId = controller?.getAttribute('aria-controls');
    if (!tabId) return;

    // Find all elements
    this.tabControllers = this.tabControllers || this.querySelectorAll('[aria-controls]');
    this.tabPanels = this.tabPanels || this.querySelectorAll('[aria-labelledby]');

    // Toggle the selected state of all tab controllers
    this.tabControllers.forEach((controller) => {
      controller.ariaSelected = controller.getAttribute('aria-controls') === tabId;
    });

    // Toggle the hidden state of all tab panels
    this.tabPanels.forEach((tab) => {
      tab.ariaHidden = tab.id !== tabId;
    });

    // Publish an event if there is one
    if (this.dataset.publishEvent) {
      publish(`${this.dataset.publishEvent}`, {
        target: this.dataset.sectionId,
        value: tabId,
      });
    }

    // Activate the focus trap if it's not already active
    if (!this.trap.active) this.trap.activate();

    // Update the trap container elements
    this.trap.updateContainerElements([this]);
  }
}

customElements.define('tab-element', TabElement);

export { TabElement };
